import React, { type PropsWithChildren } from 'react';
import type { TargetType } from '@atlassiansox/cross-flow-base-types';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { JiraModal as Modal } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import { useOnboardingModalContext } from '../../../controllers/onboarding-modal-context/index.tsx';

interface OnboardingModalComponentProps {
	targetProduct: TargetType;
	sourceComponent: string;
	ariaLabel: string;
}

export const OnboardingModalComponent = ({
	children,
	targetProduct,
	sourceComponent,
	ariaLabel,
}: PropsWithChildren<OnboardingModalComponentProps>) => {
	const { open } = useOnboardingModalContext();

	return (
		<ContextualAnalyticsData
			sourceName={sourceComponent}
			sourceType={MODAL}
			attributes={{ targetProduct }}
		>
			<ModalTransition>
				{open && (
					<>
						<FireScreenAnalytics />
						<Modal
							width="x-large"
							shouldScrollInViewport
							testId="cross-flow-onboarding-modal.common.ui.modal.modal"
							messageId="cross-flow-onboarding-modal.common.ui.modal"
							messageType="engagement"
							label={ariaLabel || 'Jira modal'}
						>
							{children}
						</Modal>
					</>
				)}
			</ModalTransition>
		</ContextualAnalyticsData>
	);
};
